import React, { FC } from 'react';
import { Badge, UncontrolledTooltip } from 'reactstrap';
import { Order, OrderItem, Payment, Refund } from '../../shared/orders/model';
import { useTranslation } from '../translations';

export function getOrderItem(order: Order, orderItemId: number): OrderItem {
  return order.orderItems.find((t) => t.id === orderItemId)!;
}

export function getRefund(order: Order, refundId: number): Refund {
  return order.refunds.find((t) => t.id === refundId)!;
}

export const PaymentStatusBadge: FC<{ readonly payment: Payment }> = ({
  payment: { status },
}): React.JSX.Element => {
  const { ts } = useTranslation();
  switch (status) {
    case 'success': {
      return <Badge color="success">{ts('succeeded')}</Badge>;
    }

    case 'failed': {
      return <Badge color="danger">{ts('failed')}</Badge>;
    }

    case 'refunded': {
      return <Badge color="info">{ts('common.refunded')}</Badge>;
    }

    default: {
      return (
        <>
          <Badge color="secondary" id="awaitingPaymentBadge">
            {ts('awaiting_payment')}
          </Badge>
          <UncontrolledTooltip target="awaitingPaymentBadge">
            {ts('the_user_has_not_entered_their_payment_details')}
          </UncontrolledTooltip>
        </>
      );
    }
  }
};
